import React, { Component } from 'react';
import _ from 'lodash';
import { Result } from 'antd';
import { withRouter } from 'react-router-dom';
import LoadingSpinner from '../../components/LoadingSpinner';
import { CONTACT_PHONE } from '../../constants';
import firebase, { db, COLLECTION_BOOKINGS, SYSTEM_LOGIN } from '../../firebase';
import logger from '../../services/logger';
import { isBookingInThePast } from '../../utils';


export function withAmendBookingDataProvider(WrappedComponent) {
    class HOC extends Component { 
        state = {
            isLoading: true,
            isUnauthorised: false,
            data: null,
            docId: null,
        };

        componentDidMount() {
            this.fetchBooking();
        }

        fetchBooking = async () => {
            const bookingUuid = _.get(this.props, 'match.params.id');

            try {
                let data = {};
                let docId = null;

                await firebase.auth().signInWithEmailAndPassword(SYSTEM_LOGIN.USER, SYSTEM_LOGIN.PASSWORD);

                const snapshot = await db.collection(COLLECTION_BOOKINGS)
                    .where('uuid', '==', bookingUuid)
                    .get();

                if (snapshot.empty) {
                    return this.handleError(`Could not find booking with a uuid of ${bookingUuid}`);
                }

                if (snapshot.size > 1) {
                    return this.handleError(`Found multiple documents with a uuid of ${bookingUuid}`);
                }

                snapshot.forEach(doc => {
                    data = doc.data();
                    docId = doc.id;
                });

                if (data.booking_cancelled) {
                    return this.handleError(`Attempted to amend a cancelled booking with a uuid of ${bookingUuid}`);
                }

                if (isBookingInThePast(data.date_time)) {
                    return this.handleError(`Attempted to amend a past booking with a uuid of ${bookingUuid}`);
                }

                this.setState({ data, docId, isLoading: false });
            } catch (e) {
                this.handleError('Error fetching document to amend: ' + JSON.stringify(e));
            }
        }

        handleError = (error = null) => {
            logger.error(error);

            this.setState({ isUnauthorised: true });
        }

        render() {
            const {
                isLoading,
                isUnauthorised,
                data,
                docId,
            } = this.state;

            if (isUnauthorised) {
                return (
                    <Result
                        status="error"
                        title="Something went wrong!"
                        subTitle={
                            <span>
                                Sorry, we could not find your booking in our records.
                                <br />
                                If you still with to amend your booking, please contact us directly on { CONTACT_PHONE }.
                            </span>
                        }
                    />
                );
            }

            if (isLoading) {
                return <LoadingSpinner />;
            }

            return (
                <WrappedComponent data={data} docId={docId} />
            );
        }
    }

    return withRouter(HOC);
}
